import { isMobileDevice } from 'src/utils/device';
import { voolistExtension } from 'src/utils/voolist-extension';

/**
 * Ask the Voolist extension to run the work this browser owes the seller's marketplaces: a takedown
 * after a sale elsewhere, an edit, posting a Grailed item again after a Grailed sale.
 *
 * Fire and forget: the run belongs to the extension, so it carries on after the page that asked has
 * moved on, and with nothing owed it stops at once. A phone has no extension, so nothing is asked there.
 */
export function startExtensionQueue() {
  if (isMobileDevice()) return;
  voolistExtension.triggerPendingPlatformSyncs().catch(() => {});
}

/**
 * Start the extension's queue once when Voolist opens. The queue also runs when Chrome starts and after
 * a save, but a seller can keep Chrome open for days; opening Voolist is a moment they are at the
 * computer. Asked only of an extension that answers, so a computer without one waits on nothing.
 */
export async function startExtensionQueueOnOpen() {
  if (isMobileDevice()) return;
  if (await voolistExtension.isInstalled()) startExtensionQueue();
}
